import axios from 'axios';
import {
  ActivityPayload,
  ActivitySubmission,
  AppliedProjectStat,
} from '../hydra';
import { apiURL } from './config';
import { requestContract } from './contract-client';
import {
  submitProsumerProjectRoute,
  createProsumerProjectAIReviewRoute,
  submitProsumerProjectAnswerRoute,
} from '@enki/contracts/prosumer/submissions';

axios.defaults.baseURL = apiURL;
axios.defaults.headers.common['x-client-id'] = 'ENKI';

export async function getProsumerProject(
  token: string,
  { projectSlug }: { projectSlug: string }
) {
  const response = await axios<null, ActivityPayload>({
    method: 'get',
    url: `/prosumer/projects/${projectSlug}`,
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
}

export async function saveProsumerProject(
  token: string,
  {
    submission,
    projectSlug,
  }: { submission: ActivitySubmission; projectSlug: string }
) {
  await requestContract(submitProsumerProjectRoute, {
    token,
    params: { projectSlug },
    body: {
      ...submission,
      answer_states: Object.fromEntries(
        Object.entries(submission.answer_states).map(([slug, answerState]) => [
          slug,
          {
            ...answerState,
            submitted_at: answerState.submitted_at?.toISOString() ?? null,
          },
        ])
      ),
    },
  });
}

export async function getProsumerProjectsDashboard(
  token: string
): Promise<Array<AppliedProjectStat>> {
  const response = await axios<null, Array<AppliedProjectStat>>({
    method: 'get',
    url: '/prosumer/projects/',
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
}

export async function createProsumerProjectAIReview(
  token: string,
  {
    sessionId,
    projectSlug,
  }: {
    sessionId: number;
    projectSlug: string;
  }
) {
  await requestContract(createProsumerProjectAIReviewRoute, {
    token,
    params: { projectSlug },
    body: {
      sessionId,
      projectSlug,
    },
  });
}

export async function validateProsumerProjectAnswerAttempt(
  token: string,
  {
    value,
    submissionId,
    questionSlug,
    projectSlug,
  }: {
    value: string;
    submissionId: number;
    questionSlug: string;
    projectSlug: string;
  }
): Promise<void> {
  await requestContract(submitProsumerProjectAnswerRoute, {
    token,
    params: { projectSlug },
    timeout: 1000 * 30,
    body: {
      value,
      submissionId,
      questionSlug,
    },
  });
}
